import { ACCESS_TABLE_PAGE_SIZE } from "../constants/access.constants";

/**
 * The rows of one page, with the page number clamped to what actually exists.
 *
 * Clamping is the whole point, and it is not defensive noise: deleting the last row of the final page — or
 * typing a term that narrows the result — leaves the stored page pointing past the end, and an unclamped
 * `slice` then renders an empty table under a non-zero total, which reads as "no match" rather than "wrong
 * page". Every catalog in this module pages in memory, so all three would have to repeat this.
 *
 * An empty list is page 1 of 1, never page 0.
 */
export function pageCountFor(totalRows: number, size: number = ACCESS_TABLE_PAGE_SIZE): number {
  return Math.max(1, Math.ceil(totalRows / size));
}

export function clampPage(page: number, totalRows: number, size: number = ACCESS_TABLE_PAGE_SIZE): number {
  return Math.min(Math.max(1, page), pageCountFor(totalRows, size));
}

export function pageSlice<T>(rows: readonly T[], page: number, size: number = ACCESS_TABLE_PAGE_SIZE): T[] {
  const safePage = clampPage(page, rows.length, size);
  return rows.slice((safePage - 1) * size, safePage * size);
}
